import {HTMLProps, ReactNode} from 'react';
import {routeTo, PageInfo} from '../util/PageRouter';

export type IProps<T = any> = IPropsDefault | IProps1 | IProps2<T>;
interface IPropsDefault extends HTMLProps<HTMLDivElement> {
  rightElement?: ReactNode | string;
  rightWrapperClassName?: string;
  pageInfo?: never;
  rowId?: never;
  onClickRow?: never;
}
interface IProps1 extends Omit<IPropsDefault, 'pageInfo'> {
  pageInfo: PageInfo;
}
interface IProps2<T> extends Omit<IPropsDefault, 'rowId' | 'onClickRow'> {
  rowId?: T;
  onClickRow: (rowId?: T) => void;
}

export default function Row<T>({
  rowId,
  rightElement,
  rightWrapperClassName,
  pageInfo,
  onClickRow,
  style,
  className,
  children,
  ...rest
}: IProps<T>) {
  return (
    <div
      className={cn(
        'relative flex items-center justify-between',
        (pageInfo || onClickRow) && 'cursor-pointer',
        className
      )}
      style={style}
      onClick={() => {
        if (pageInfo) {
          routeTo(pageInfo);
        } else if (onClickRow) {
          rowId !== undefined ? onClickRow(rowId) : onClickRow();
        }
      }}
      {...rest}
    >
      {children}
      <div
        className={cn('flex items-center flex-none', rightWrapperClassName, {
          'ml-auto': children,
        })}
      >
        {rightElement}
      </div>
    </div>
  );
}
